import { Rate } from 'antd';
import Axios from 'axios';
import React, { useEffect, useState, useRef } from 'react'
import { Panel, PanelGroup, Row, Col, Button, Avatar, Alert, SelectPicker, FormControl, Form } from 'rsuite';
import { Select } from 'antd';
import { Input, Space, Modal } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { BASE_PATH } from '../constants';
import StartSessionPerfil from './StartSessionPerfil';

import './StartSession.css';

export const StartSession = (props) => {
    const { Option } = Select;
    const [show, setShow] = useState(false);
    const [appointmentt, setAppointmenttt] = useState([])
    useEffect(() => {
       
        //onSearch()
    }, [])
   
    const handelSession = (post) => {
       // props.cerrarModalListaTutores();
        props.setIsModalVisibleddd(post)
    }
    
    const { Search } = Input;

    var lenguaje = ""
    var minutos = ""
    var monto = ""
    var nivel = ""
    const handlerefresh =() => {
        minutos = ""
        monto = ""
        lenguaje = ""
        nivel = ""
        props.refresh()
    }
    const onSearch =async(value) => {
        if(value != ""){
            try {
                let res = await Axios.get(`${BASE_PATH }/Tutor/available?getNumber=3&search=${value}`,{ 
              
                })
                if(res.status===200){
                    props.onSearch(res.data)
                  //  console.log(res)
                }
            }catch (e){
                console.log(e)
            }
        }else {
        try {
            let res = await Axios.get(`${BASE_PATH }/Tutor/available?getNumber=3`,{ 
                  
            })
            if(res.status===200){
                props.onSearch(res.data)
              //  console.log(res)
            }
        }catch (e){
            console.log(e)
        }
        console.log(value)
        }
    }
/*onClick={()=> onSubmit(post)}*/

const initForm = {
    firstName: "",
    bankaccount:"",
    payoaccount:"",
    lastName: "",
    email: "",
    gender: '',
    minutes:'',
    level:'',
    language:'',
    money:'',
    bank:'',
    countryId: 1,
    city: "",
    appTypeId: 3,
    birthdate: "",
}
const minutes = [{
    "label": "15",
    "value": 15
}, {
    "label": "30",
    "value": 30
},{
    "label": "45",
    "value": 45
}, {
    "label": "60",
    "value": 60
},]

const money = [{
    "label": "$5",
    "value": 5
}, {
    "label": "$10",
    "value": 10
},{
    "label": "$15",
    "value": 15
}, {
    "label": "$20",
    "value": 20
},]

const level = [{
    "label": "Basic",
    "value": 1
}, {
    "label": "Medium",
    "value": 2
}, {
    "label": "Advanced",
    "value": 3
}]

const language = [{
    "label": "English",
    "value": "English"
},{
    "label": "Spanish",
    "value": "Spanish"
},
{
    "label": "German",
    "value": "German"
},{
    "label": "French",
    "value": "French"
},{
    "label": "Q'eqchi",
    "value": "Q'eqchi"
},{
    "label": "Mam",
    "value": "Mam"
}, {
    "label": "kaqchikel",
    "value": "kaqchikel"
},]

    const handleChange =(value) => {
        minutos = value
        setTimeout(() => {
            onSearchT()
        }, 2000);
    }

    var lenguaje = ""
    const handleChangeL =(value) => {
        lenguaje = value.toString()
        setTimeout(() => {
            onSearchT()
        }, 2000);
    }

    const handleChangeM =(value) => {
        monto = value
        setTimeout(() => {
            onSearchT()
        }, 2000);
    }

    const handleChangeN =(value) => {
        nivel = value
        setTimeout(() => {
            onSearchT()
        }, 2000);
    }

    const onSearchT =async() => {
        try {
            let res = await Axios.get(`${BASE_PATH}/Tutor/available?getNumber=3&minutes=${minutos == undefined ? "" : minutos}&money=${monto == undefined ? "" : monto}&level=${nivel == undefined ? "" : nivel}&language=${lenguaje}`,{ 
            
            })
            if(res.status===200){
                props.onSearch(res.data)
                //  console.log(res)
            }
        }catch (e){
            console.log(e)
        }
    }
    return (
        <div
        style={{
            marginTop:'1rem'
        }}>
            <h4>You can filter your search, find your right Tutor.</h4>      
            <Row className="">
                <Col md={6} xs={12} className='mb-3'>
                    <label className="mt-3">Minutes of <br/> the session</label>
                    <Select  style={{ width: '100%' }} placeholder="Seleccionar"  onChange={handleChange} allowClear>
                        {minutes.map((post) =>
                            <Option className="form-control" gutter={16} key={post.value} value={post.value} >{post.label}</Option>
                        )}
                    </Select>
                </Col>
                <Col md={6} xs={12} className='mb-3'>
                    <label className="mt-3">Money to  <br/> invest</label>
                    <Select  style={{ width: '100%' }} placeholder="Seleccionar" onChange={handleChangeM} allowClear>
                        {money.map((post) =>
                            <Option className="form-control" gutter={16} key={post.value} value={post.value} >{post.label}</Option>
                        )}
                    </Select>
                </Col>
                <Col md={6} xs={12} className='mb-3'>
                    <label className="mt-3">Language  <br/> Level</label>
                    <Select  style={{ width: '100%' }} placeholder="Seleccionar" onChange={handleChangeN} allowClear>
                        {level.map((post) =>
                            <Option className="form-control" gutter={16} key={post.value} value={post.value} >{post.label}</Option>
                        )}
                    </Select>
                </Col>
                <Col md={6} xs={12} className='mb-3'>
                    <label className="mt-3">Type of <br/> Language</label>
                    <Select  style={{ width: '100%' }} placeholder="Seleccionar" onChange={handleChangeL}  mode="multiple" >
                        {language.map((post) =>
                            <Option className="form-control" gutter={16} key={post.value} value={post.value} >{post.label}</Option>
                        )}
                    </Select>
                </Col>
                {/*<Col>
                    <Search
                        placeholder="Tutor`s name"
                        allowClear
                        enterButton="Search"
                        size="large"
                        onSearch={onSearch}
                        />
                </Col>*/}
              
            </Row>
            { 
            props.setTutores.map((post) =>
                <Row key={post.id} className="mt-4">
                        <Col>
                            <Panel    
                            style={{
                                cursor:"pointer"
                            }} 
                            onClick={()=> handelSession(post)}
                            className="panel__startsession" >
                                <Row className="mt-4">
                                    <Col  lg="9" xs="12">
                                    <Avatar size="lg"
                                            circle 
                                            className="avatar__startsession"
                                            src={post.imageProfile&&post.imageProfile}
                                            />
                                    </Col>
                                    <Col lg="14"  xs="12">
                                        <p
                                        className="ficha__startsession">
                                        <h5
                                        className="heavy">
                                            {post.name}
                                        </h5>
                                        <br/>
                                        <Rate disabled defaultValue={post.rating} />
                                        <br/>
                                        <p
                                        style={{ 
                                            paddingTop:'0.4rem',
                                            marginBottom:'-1rem'}}>
                                                 { /* {post.themes} */ }
                                        </p>
                                        <br/>
                                        <text>
                                            {post.city}
                                        </text>
                                        </p>
                                    </Col> 
                                </Row>
                            </Panel>
                             
                        </Col>
                </Row>
            )}   
           <Row>
               <Col md={24} className="rs-flex-box-grid rs-flex-box-grid-bottom rs-flex-box-grid-center mt-4">
                    <button  
                    className="heavy  search-fixed" color="blue" onClick={handlerefresh} >
                      Refresh
                    </button>
               </Col>
           </Row> 
        </div>
    )
}